import Vue from 'vue'
import VueRouter from 'vue-router'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)

import { getnav } from '@/assets/js/common.js'
import store from '@/store'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import oAuth from '@/views/oAuth'
import { getCookieToken, removeToken, serSignSource } from '@/utils/tool'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    hidden: true,
    redirect: '/login'
  },
  {
    path: '/oAuth',
    hidden: true,
    component: oAuth
  },
  {
    path: '/',
    component: Home,
    hidden: true,
    leaf: true, // 只有一个节点
    meta: {
      title: 'Home',
      icon: 'fa fa-address-card'
    },
    children: [
      {
        path: '/Login',
        component: Login,
        meta: {
          title: '登录',
          icon: 'el-icon-star-on'
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

// 路由拦截
router.beforeEach(async(to, from, next) => {
  if (to.path === '/oAuth') {
    next()
    return
  }
  // 判断是否token
  if (getCookieToken()) {
    if (store.state.curid === 0 && sessionStorage.getItem('refresh') === '1') {
      sessionStorage.removeItem('refresh')
      if (VueCookies.get('yzd_qyState') == 0) {
        // 审核中
        next({ path: '/Spload' })
      } else if (VueCookies.get('yzd_qyState') == 1) {
        if (VueCookies.get('isInit') == 'true') {
          next({ path: '/Kccshlc' })
        } else {
          // 有token跳转登陆页面
          next({ path: '/Dashboard' })
        }
      } else if (VueCookies.get('yzd_qyState') == 3) {
        // 未通过
        next({ path: '/Spfail' })
      } else if (VueCookies.get('yzd_qyState') == 5) {
        // 未申请
        next({ path: '/Rwsq' })
      }
    }
    // 有token
    if (to.path === '/login') {
      if (VueCookies.get('yzd_qyState') == 0) {
        // 审核中
        next({ path: '/Spload' })
      } else if (VueCookies.get('yzd_qyState') == 1) {
        if (VueCookies.get('isInit') == 'true') {
          next({ path: '/Kccshlc' })
        } else {
          // 有token跳转登陆页面
          next({ path: '/Dashboard' })
        }
      } else if (VueCookies.get('yzd_qyState') == 3) {
        // 未通过
        next({ path: '/Spfail' })
      } else if (VueCookies.get('yzd_qyState') == 5) {
        // 未申请
        next({ path: '/Rwsq' })
      }
    } else {
      if (store.state.curid === 0) {
        store.commit('setcurid', 1)
        await editnav()
        next({ ...to, replace: true })
      } else {
        next()
      }
    }
  } else {
    // 无token
    store.commit('setcurid', 0)
    // next({ path: '/login' })
    // 防止死循环
    if (to.path === '/login') {
      next()
    } else {
      next({ path: '/login' })
    }
  }

  function editnav() {
    getnav().then(e => {
      // 异步路由
      var data = e.data.data.asyncRoutes
      // 开发环境直接加载本地数据
      if (process.env.VUE_APP_SHOW_TEST_MENU === 'true') {
        data = JSON.parse(JSON.stringify(require('./data').default))
      }
      store.commit('setnav', data)
      store.commit('SET_DATA', e.data.data)
      var arr = []
      data.forEach(item => {
        var child = []
        item.children.forEach(item2 => {
          child.push(
            {
              name: item2.component,
              path: item2.path,
              component: () => import('../views/' + item2.component + '.vue'),
              meta: {
                title: item2.meta.title,
                icon: item2.meta.icon
              }
            }
          )
        })

        arr.push({
          path: item.path,
          component: () => import('../views/' + item.component + '.vue'),
          meta: {
            title: item.meta.title,
            icon: item.meta.icon
          },
          hidden: item.hidden,
          leaf: item.leaf,
          children: child
        })
      })
      router.addRoutes(arr)
      window.sessionStorage.setItem('signSource', e.data.signSource)
    }).catch(() => {
      removeToken()
      router.push('/login')
    })
  }
})

export default router
